/** 是否放开前端ttq埋点 */
export const isEnableTtqTrack = () => {
  const domain = window.location.host;
  return ["www.lydrive.top", "www.xcugpox.top", "localhost"].includes(domain) && localStorage.source === '4';
};

/** 是否关闭埋点上报 */
export const isDisableTrackM = () => {
  const domain = window.location.host;
  return ["www.oytraining.top", "www.kpgohg.top", "www.fatml.top", "localhost"].includes(domain);
};


// WEBPACK FOOTER //
// ./src/util/experiment.js